import { FormControl } from "@chakra-ui/form-control";
import { Input, InputLeftElement, InputRightElement,InputGroup } from "@chakra-ui/input";
import { Box, Text } from "@chakra-ui/layout";
import "./styles.css";
import { Tooltip } from "@chakra-ui/tooltip";

import { IconButton, Spinner, useToast, Button, Divider,  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,} from "@chakra-ui/react";
import { getSender, getSenderFull } from "../config/ChatLogistics";
import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowBackIcon, 
    LockIcon, 
    UnlockIcon,ChevronUpIcon, 
    ViewIcon,ViewOffIcon, AttachmentIcon } from "@chakra-ui/icons";
import ProfileModal from "./misc/ProfileModal";
import ScrollableChat from "./ScrollableChat";
// import Lottie from "react-lottie";
import animationData from "../animations/typing.json";

import io from "socket.io-client";

import UpdateGroupChatModal from "./misc/UpdateGroupChatModal";
import { ChatState } from "../context/chatProvider";
import  EnvRoute  from '../middleware/envRoute';
import QuickShield from "./misc/QuickShield";
import VideoComp from "./VideoComp";
const ENDPOINT = EnvRoute('prod'); 

var CryptoJS = require("crypto-js");
// var aes256 = require('aes256');

// const URL_KEY = (env,id)=>{
//     if(env ==='dev'){return `http://localhost:5000`}
//     else if(env ==='dep'){return `https://tin-can.netlify.app`}
//     else {return `https://tin-can.netlify.app`}
// }

// ENDPOINT=URL_KEY('dev')


var socket, selectedChatCompare;

// const Cryptr = require('cryptr');

const SingleChat = ({ fetchAgain, setFetchAgain }) => {
  const { selectedChat, setSelectedChat, user, notification, setNotification , globalEnc , setGlobalEnc} = ChatState();

  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEncrypted, setIsEncrypted] = useState(false)
  const [newMessage, setNewMessage] = useState("");
  const [encryptMessg, setEncryptMessg] = useState([]);
  const [socketConnected, setSocketConnected] = useState(false);
  const [typing, setTyping] = useState(false);
  const [istyping, setIsTyping] = useState(false);
  const [send, setSend] = useState(false);
  const [glbEncrypt, setGlbEncrypt]  = useState (true)
  const toast = useToast();
  
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  
  
  var key = `${selectedChat?._id}`;

  const fetchMessages = async () => {
    if (!selectedChat) return;

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`, 
        },
      };

      setLoading(true);

      const { data } = await axios.get(
        `${ENDPOINT}/api/message/${selectedChat?._id}`,
        config
      );
      console.log('SingleChat data:',data)
      setMessages(data);
      setLoading(false);

      socket.emit("join chat", selectedChat._id);
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: "Failed to Load the Messages",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
    }
  };

  const addFile = () =>{
    console.log('addFile: No files yet.')
  }

  const clickSend = async (event)=>{
    // event.preventDefault()
    setSend(true)
    sendMessage()
    console.log("click send event:",event.target)
  }

  const encrypt = async () =>{

      let cipher = CryptoJS.AES.encrypt(newMessage, key).toString()
      console.log("[encrypt] newMessage:",newMessage)
      setEncryptMessg(cipher)
      console.log("[encrypt] encryptMessg:",encryptMessg)
      console.log("[encrypt] decryptMessg:",encryptMessg)
  }
const handleMessage  =  (e) =>{
  if(isEncrypted){
        encrypt()
        if(send){
          sendMessage(e)
        }
      }else{
        sendMessage(e)
      }
}
  const sendMessage = async (event) => {
    // event.preventDefault()
    console.log("newMessage:",newMessage)

    // if ((send)||(event.key === "Enter" && newMessage)) {
    if ((send)||(event.key == "Enter" && newMessage)) {
      setSend(true)
      socket.emit("stop typing", selectedChat._id);
      try {
        const config = {
              headers: {
               contentType : "application/json",
                Authorization: `Bearer ${user.token}`,
                credentials: true
              },
            };
            setNewMessage("");
            setEncryptMessg("");
            console.log("encrypt_messg: ", encryptMessg)
            const { data } = await axios.post(`${ENDPOINT}/api/message`,
            {
              sender: user._id,
              content: isEncrypted ? encryptMessg : newMessage,
              chatId: selectedChat._id.trim(),
              isEncrypted: isEncrypted? true: false,
            },
            config
            );
            console.log('data: ', data)
            socket.emit("new message", data);
            setMessages([...messages, data]);
          } catch (error) {
            toast({
              title: "Error Occured!",
              description: "Failed to send the Message",
              status: "error",
              duration: 5000,
              isClosable: true,
              position: "bottom",
            });
          }
          setSend(false)
        }
  };
useEffect(() => {
    socket = io(ENDPOINT);
    socket.emit("setup", user);
    socket.on("connected", () => setSocketConnected(true));
    socket.on("typing", () => setIsTyping(true));
    socket.on("stop typing", () => setIsTyping(false));

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchMessages();
    console.log("messages :", messages)
    selectedChatCompare = selectedChat;
    // eslint-disable-next-line
  }, [selectedChat]);

  useEffect(() => {
    socket.on("message recieved", (newMessageRecieved) => {
      if (
        !selectedChatCompare || // if chat is not selected or doesn't match current chat
        selectedChatCompare._id !== newMessageRecieved.chat._id
      ) {
        if (!notification.includes(newMessageRecieved)) {
          setNotification([newMessageRecieved, ...notification]);
          setFetchAgain(!fetchAgain);
        }
      } else {
        setMessages([...messages, newMessageRecieved]);
      }
    });
  });

  const typingHandler = (e) => {
    setNewMessage(e.target.value);

    if (!socketConnected) return;

    if (!typing) {
      setTyping(true);
      socket.emit("typing", selectedChat._id);
    }
    let lastTypingTime = new Date().getTime();
    var timerLength = 3000;
    setTimeout(() => {
      var timeNow = new Date().getTime();
      var timeDiff = timeNow - lastTypingTime;
      if (timeDiff >= timerLength && typing) {
        socket.emit("stop typing", selectedChat._id);
        setTyping(false);
      }
    }, timerLength);
  };
  return (
     <>
      {selectedChat ? (
        <>
          <Text
            fontSize={{ base: "18px", md: "22px" }}
            pb={3}
            px={2}
            w="100%"
            fontFamily="Gilroy"
            display="flex"
            justifyContent={{ base: "space-between" }}
            alignItems="center"
            whiteSpace={'nowrap'}
            
          >
            <IconButton
              display={{ base: "flex", md: "none" }}
              // boxShadow={'bxshd.inset_lt_bl'}
              border={'1px solid #868686'}
              borderBottom={'none'}
              borderRight={'none'}
              
              variant="ghost" 
            color={'#868686'}
              borderRadius = "0px 10px  0px 10px"
              icon={<ArrowBackIcon />}
              onClick={() => setSelectedChat("")}
            />
            {messages &&
              (!selectedChat.isGroupChat ? (
                <>
                  {getSender(user, selectedChat.users,selectedChat.id)}
                  <ProfileModal
                    user={getSenderFull(user, selectedChat.users)}
                  />
                </>
              ) : (
                <>
                  {selectedChat.chatName.toUpperCase()}
                  <UpdateGroupChatModal
                    fetchMessages={fetchMessages}
                    fetchAgain={fetchAgain}
                    setFetchAgain={setFetchAgain}
                  />
                </>
              ))}
          </Text>
          <Box
            display={'flex'}
            // flexDirection={{base:'row', sm:'column'}}
            flexDirection={'row'}

          
          >

           <Tooltip label={globalEnc?'click to show encrypted messages':'click to hide encrypted messages'} placement="bottom" hasArrow>
          <IconButton  
          // h={'30px'}o
          // w={'25px'}
          // m={0}
          fontSize={"25px"}
          display={{ base: "flex" }}
            icon={globalEnc?<ViewOffIcon />:<ViewIcon />}
           onClick={()=>setGlobalEnc(!globalEnc)} 
            border={'none'}
            color={globalEnc?'limegreen':'red'}
            variant="ghost" 
             borderRadius={'10px 0px 10px 0px'}
              borderBottom={'none'}
           />
           </Tooltip>
           <QuickShield />
          </Box>
          <Box
            display="flex"
            flexDir="column"
            justifyContent="flex-end"
            p={3}
            bg="#E8E8E8"
            w="100%"
            h="100%"
            borderRadius="10px 0 10px 10px"
            overflowY="hidden"
            backgroundColor={"bgs.bgsMain"}
            boxShadow={"bxshd.inset_blk"}
            
            // boxShadow={"bxshd.chtBtn"}
            backgroundImage={"url('./assets/BodyBG2.png')"}
            // backgroundImage={"url('./Gradient_01_Frame1_60p.png')"}
            backgroundSize={"cover"}
          >

            {loading ? (
              <Spinner
                size="xl"
                w={20}
                h={20}
                alignSelf="center"
                margin="auto"
              />
            ) : (
              <>
                <VideoComp roomId={selectedChat?._id.trim()}/>
              <div className="messages">
                <ScrollableChat messages={messages}/>
              </div>
              </>
            )}

            <FormControl
              onKeyUp={(e)=>{
                if ((e.key === "Enter")) {
                  handleMessage(e)
                  setSend(true)
                }
              }}
              id="first-name"
              isRequired
              mt={3}
            >
              {istyping ? (
                <div>
                  typing...
                  {/* <Lottie
                    options={defaultOptions}
                    height={50}
                    width={70}
                    style={{ marginBottom: 15, marginLeft: 0 }}
                  /> */}
                </div>
              ) : (
                <></>
              )}
              <InputGroup>
              <Input
                variant="filled"
                bg="#E0E0E0"
                placeholder="Enter a message.."
                value={newMessage}
                onChange={typingHandler}
                boxShadow={"bxshd.chtBtn"}
                backdropFilter={"blur(4px)"}
                border = {`1px solid #868686`}
                _placeholder={{ opacity: 0.9, color: '#868686' }}
                autoComplete="off"
              />
          
        <InputLeftElement  >
           <Tooltip label={isEncrypted?'click to send unencrypted messages':'click to send encrypted messages'} placement="top" hasArrow>
            <Button m ={1} h={'2em'} onClick={()=>{
              setIsEncrypted(!isEncrypted)
            }} 
            backgroundColor={'rgba(0, 0, 0, 0)'}>
          {isEncrypted?<LockIcon color={'limegreen'}/>:<UnlockIcon color={'red'}/>}
            </Button>    
        </Tooltip>
        </ InputLeftElement>
       
    
        <InputRightElement p={0}>
          <IconButton 
            m ={0}
            //  h={'2em'} mr={'em'}
            
            icon={<AttachmentIcon/>}
            onClick={(event)=>{addFile(event)}} 
            backgroundColor={'rgba(0, 0, 0, 0)'} 
            key='uploadButton'>
          
          </IconButton>
          <Button m ={1} h={'2em'} mr={'3em'} onClick={(event)=>{clickSend(event)}} backgroundColor={'rgba(0, 0, 0, 0)'} key='sendChat'>
          send
          </Button>
        </ InputRightElement>
        </InputGroup>
            </FormControl>
          </Box>
        </>
      ) : (
        // to get socket.io on same page
        <Box display="flex" alignItems="center" justifyContent="center" h="100%" >
         <Box
        display="flex"
        flexDir="column"
        p={3}
        // bg="rgba(250,250,250,0.2)"  
        bg="rgba(250,250,250,0.9)"  
        backgroundImage={"url('./assets/BodyBG2.png')"}
        // bg="#F8F8F8"  
        w="100%"
        h="100%"
        borderRadius="10px 0 10px 10px"
        overflowY="hidden"
        // backgroundImage={"url('./assets/BodyBG.png')"}
        // backgroundColor={"bgs.accntBx"}
        boxShadow={"bxshd.inset_blk"}
         backdropFilter={"blur(2px)"} 
         justifyContent={'center'}
         textAlign={'center'}
      >
         
        
          <Text fontSize="3xl" pb={3} fontFamily="Gilroy">
            Click on a user to start chatting
          </Text>
        </Box>
      </Box>
      )}
    </>
  )
}

export default SingleChat